import { combineReducers } from "redux";
import collections from "./collections";

export default combineReducers({
    collections: collections,
  });